import { render, staticRenderFns } from "./headFirstWidge.vue?vue&type=template&id=006164ea&scoped=true"
import script from "./headFirstWidge.vue?vue&type=script&lang=js"
export * from "./headFirstWidge.vue?vue&type=script&lang=js"
import style0 from "./headFirstWidge.vue?vue&type=style&index=0&id=006164ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006164ea",
  null
  
)

export default component.exports